import { OutlinedInput, Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import { getDollorValue } from "src/utils/genericFunctions";

const DollarInputItem = ({
  rowData,
  headerId,
  handleChange,
  editMode
}: {
  rowData: any;
  headerId: string;
  handleChange?: (item: string, id: string | number, value: any) => any;
  editMode?: boolean;
}) => {
  const handleChangeValue = useCallback(
    (event: any) => {
      handleChange(rowData?.type, rowData[headerId]?.id, event?.target?.value);
    },
    [handleChange, headerId, rowData]
  );

  const handleFocus = useCallback((event: any) => {
    event.target.select();
  }, []);

  return (
    <>
      {editMode ? (
        <Stack>
          <OutlinedInput
            disabled={rowData[headerId]?.disabled || rowData?.isDisabled}
            slotProps={{
              input: { style: { textAlign: "right" }, maxLength: 11 }
            }}
            value={getDollorValue(rowData[headerId]?.value || "")}
            onChange={handleChangeValue}
            onFocus={handleFocus}
            sx={{ height: "36px", fontSize: "14px", width: "100%" }}
            data-testid={rowData[headerId]?.testId}
          />
        </Stack>
      ) : (
        <Typography
          fontSize={14}
          sx={{
            opacity: `${rowData?.isDisabled ? 0.5 : 1}`
          }}
        >
          {rowData[headerId]?.value}
        </Typography>
      )}
    </>
  );
};

export default DollarInputItem;
